import  { useMemo, useState } from 'react';

const useRoles = () => {

    const ROLES = useMemo(() => ({
        ROLE_ADMIN: "admin",
        ROLE_APPLICANT: "applicant",
        ROLE_COMPANY: "company"
    }), [])

    const [role] = useState(localStorage.getItem("rol"))




    return [role, ROLES]
    
};

export default useRoles;